export const DATAHUB_LINK_MAX = 2147483647

export interface CnDatahubCategory {
  id: string
  name: string
  sharedSourceTable?: string | null
}

export interface CnDatahubCategoryAccess {
  id: string
  orgaId: string
  categoryId: string
  overrideName?: string | null
  color: string
  linkContactMax: number
  linkAttachmentMax: number
  linkEntrepriseMax: number
  linkRdvMax: number
  removeManualCreation?: boolean | null
}

export interface CnDatahubCategoryColumn {
  id: string
  categoryId: string
  label: string
  datakey: string
  categoryAccessId?: string | null
  categoryColumnId?: string | null
  name: string
  type: DatahubColumnType
  required: boolean
  visible: boolean
  options?: string | null
  description?: string | null
  orderKey: number
}

export interface CnDatahubCategoryAccessFilter {
  id: string
  categoryAccessId: string
  jsonFilter: string
}

export type DatahubColumnType = 'text' | 'select' | 'entier' | 'decimal' | 'date' | 'boolean' | 'multiline-text' | 'multiple-labels'

/**
 * Options for the column type
 * @returns The options for the column type (label and value)
 */
export const DATAHUB_COLUMN_TYPE_OPTIONS: { label: string; value: DatahubColumnType }[] = [
  { label: 'Texte', value: 'text' },
  { label: 'Liste déroulante', value: 'select' },
  { label: 'Entier', value: 'entier' },
  { label: 'Décimal', value: 'decimal' },
  { label: 'Date', value: 'date' },
  { label: 'Booléen', value: 'boolean' },
  { label: 'Texte multiligne', value: 'multiline-text' },
  { label: 'Labels multiples', value: 'multiple-labels' },
]

export interface SharedCategoryConfig {
  category: CnDatahubCategory
  defaultColumns: CnDatahubCategoryColumn[]
  access: CnDatahubCategoryAccess | null
  filter: CnDatahubCategoryAccessFilter | null
  columnOverrides: CnDatahubCategoryColumn[]
}

export interface PrivateCategoryConfig {
  category: CnDatahubCategory
  access: CnDatahubCategoryAccess
  columns: CnDatahubCategoryColumn[]
}

/** Private category from another organisation, returned as a copy template. */
export interface PrivateCategorySource extends PrivateCategoryConfig {
  orgaName: string
}

export interface DatahubSaveData {
  sharedCategories: SharedCategoryConfig[]
  privateCategories: PrivateCategoryConfig[]
}
